import React, { useState } from "react";
import {
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mui/material";
import "../styles/pages/dashboard.css"
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../utils/Api";

const Topbar = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openLogoutConfirm, setOpenLogoutConfirm] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    setOpenLogoutConfirm(true);
    handleClose();
  };

  const handleLogoutClose = () => {
    setOpenLogoutConfirm(false);
  };

  const handleLogoutConfirm = () => {
    localStorage.removeItem("token");
    // localStorage.removeItem("role");
    // localStorage.removeItem("name");
    // localStorage.removeItem("email");
    // localStorage.removeItem("logo");
    navigate("/superadmin");
    window.location.reload();
  };

  return (
    <section className="topbar">
      <div className="topbar-main">
        <div>
          <Tooltip title="Account">
            <IconButton
              onClick={handleClick}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              sx={{ p: 0.5 }}
            >
              <Avatar src={`${api}`} />
              {/* <Box sx={{ ml: 1.5, textAlign: 'left', display: { xs: 'none', sm: 'block' } }}>
                <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 600, color: '#333', lineHeight: 1.2 }}>
                  {user_name || 'Super Admin'}
                </Typography>
                <Typography variant="caption" sx={{ color: '#666', fontSize: '11px', display: 'block' }}>
                  {user_email || 'admin@example.com'}
                </Typography>
              </Box> */}
            </IconButton>
          </Tooltip>
          <Menu
            className="menu-container"
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <MenuItem>
              {" "}
              <Link className="link" to="/superadmin/changePassword">
                Reset Password{" "}
              </Link>
            </MenuItem>
            <MenuItem className="logout-btn" onClick={handleLogoutClick}>Logout</MenuItem>
          </Menu>
        </div>
      </div>

      <Dialog
        open={openLogoutConfirm}
        onClose={handleLogoutClose}
        aria-labelledby="logout-dialog-title"
        aria-describedby="logout-dialog-description"
      >
        <DialogTitle id="logout-dialog-title">
          {"Confirm Logout"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="logout-dialog-description">
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleLogoutClose} sx={{ color: 'grey.500' }}>Cancel</Button>
          <Button onClick={handleLogoutConfirm} autoFocus color="error" variant="contained">
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </section>
  );
};

export default Topbar;
